// extracted by mini-css-extract-plugin
module.exports = {"promoCountdownBadge":"PromotionalCountdownTimer_promoCountdownBadge__4ZrMM"};